(function (Drupal, once) {
  Drupal.behaviors.searchViewHeading = {
    attach(context) {
      once("search-view-heading", ".search-api-view-section", context).forEach(
        function (section) {
          if (section.querySelector(".search-results-heading")) {
            return;
          }

          const params = new URLSearchParams(window.location.search);
          const term = params.get("search_api_fulltext");
          if (!term) {
            return;
          }

          // Build heading element.
          const heading = document.createElement("h2");
          heading.className = "h2 mb-8 fw-normal search-results-heading";
          heading.textContent = Drupal.t("Ihre Suchergebnisse für “@term”", {
            "@term": term,
          });

          // Wrap heading in Bootstrap row/col.
          const row = document.createElement("div");
          row.className = "row";
          const col = document.createElement("div");
          col.className = "col-md-6 col-12";
          col.appendChild(heading);
          row.appendChild(col);

          // Insert row after exposed form.
          const containerDiv = section.querySelector(".container") || section;
          const formWrapper =
            containerDiv.querySelector(".mb-4") || containerDiv;
          formWrapper.insertAdjacentElement("afterend", row);

          // If there are no results (no .view-rows but empty variable was rendered),
          // add fallback message.
          if (!section.querySelector(".view-rows")) {
            const p = document.createElement("p");
            p.className = "fs-7";
            const homeUrl = drupalSettings?.path?.baseUrl || "/";
            p.innerHTML = Drupal.t(
              'Keine Ergebnisse gefunden. <a href="@url">Hier geht es zurück zur Startseite.</a>',
              {
                "@url": homeUrl,
              }
            );
            col.appendChild(p);
          }
        }
      );
    },
  };
})(Drupal, once);
